export default __webpack_public_path__ + "static/Accelerator_logo-bf88891363a86a5a24a6e97ee2d19aa8.png";